<template>
  <div class="o-card u-padding-xsmall" id="changed-logs">
    <LockedView v-if="lockedPage">
      {{ $t("batteryDetail.changedLogsLocked") }}
    </LockedView>
    <loading v-else-if="getCycleChangedLogsLoadingById"></loading>
    <div v-else>
      <Table
        i18n
        no-search
        :loading="getCycleChangedLogsLoadingById"
        no-card
        checkable
        :checkValue="checkedList"
        @change:checkedList="checkedList = $event"
        :headers="headers"
        :items="changedLogs"
      >
        <template #new-button>
          <div class="u-display-flex u-width-100% u-justify-content-flex-end">
            <ExcelExport
              :fileName="`${cycle.serialNumber}-export-${$date.format(
                new Date()
              )}`"
              :fields="getExcelFields()"
              :data="checkedList.length > 0 ? checkedList : changedLogs"
            >
              <template #button="{ showExcell }">
                <Button
                  @click="showExcell()"
                  variant="light-success"
                  class="u-margin-right-xsmall"
                >
                  <i class="icofont-arrow-up"></i> {{ $t("common.export") }}
                </Button>
              </template>
            </ExcelExport>
          </div>
        </template>
        <template #name="{ item }">
          {{ item.serialNumber }}
          <div>{{ $date.format(item.createdDate) }}</div>
        </template>
        <template #userInfo="{ item }">
          <div>
            {{ item.userInfo.fullname }}
          </div>
        </template>
        <template #action="{ item }">
          <div>
            <div class="u-margin-bottom-xsmall">
              <chip
                class="u-margin-0"
                :variant="item.isActive ? 'success' : 'danger'"
              >
                {{
                  item.isActive ? $tc("common.active") : $tc("common.passive")
                }}
              </chip>
            </div>
            <router-link
              :to="{ name: 'cycle-detail', params: { id: item.id } }"
            >
              <Button size="xs" variant="info" :disabled="item.id === cycle.id">
                <i class="icofont-eye"></i>
                {{
                  item.id === cycle.id
                    ? $t("common.alreadyView")
                    : $t("common.view")
                }}
              </Button>
            </router-link>
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Table from "../Base/Table/index.vue";
import Button from "../Base/Button.vue";
import Chip from "../Base/Chip.vue";
import cycleExportFields from "@/components/Cycles/cycleExportFields";
import ExcelExport from "../Base/ExcelExport.vue";
import LockedView from "../LockedView/index.vue";

export default {
  name: "ChangedLogs",
  mixins: [cycleExportFields],
  components: {
    Table,
    Chip,
    Button,
    ExcelExport,
    LockedView,
  },
  data() {
    return {
      checkedList: [],
      headers: [
        {
          col: 12,
          sm: 6,
          md: 6,
          lg: 6,
          title: "cyclesForm.seriNo",
          value: "name",
        },
        {
          col: 6,
          sm: 3,
          md: 3,
          lg: 3,
          title: "common.userInfo",
          value: "userInfo",
        },
        {
          col: 6,
          sm: 2,
          md: 2,
          lg: 2,
          title: "common.action",
          value: "action",
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getCycleChangedLogsById",
      "getCycleChangedLogsLoadingById",
    ]),
    changedLogs() {
      return this.getCycleChangedLogsById(this.cycle.id).items;
    },
    exportFields() {
      return []; // this.getExcelFields();
    },
    lockedPage() {
      return !this.cycle.id || !this.cycle.isPermission;
    },
  },
  props: {
    cycle: {
      required: true,
      type: Object,
    },
  },
  methods: {
    async getChangedLogs() {
      if (this.cycle?.id)
        if (this.cycle.isPermission)
          await this.$store.dispatch("getCycleChangedLogsById", {
            cycleId: this.cycle.id,
          });
    },
  },
  mounted() {
    this.getChangedLogs();
  },
};
</script>

<style></style>
